import authRoute from "./authRoute";
import appsRoute from "./appsRoute";

export const publicRoutes = [...appsRoute];
export const protectedRoutes = [...authRoute];
